export default {
    unauthorized: {
        title: 'Dostop zavrnjen',
        bodyBefore: 'Nimate obsega',
        bodyAfter: '. Za dostop se obrnite na svojega skrbnika.',
    },
}
